/**
 * Place to store comments pinboard mutable state.
 * The `state` property within the store class contains the
 * actual data that changes.
 *
 * @see https://vuejs.org/v2/guide/state-management.html#Simple-State-Management-from-Scratch
 */

/**
 * Interface for the state property inside the store
 */
export interface ICommentsPinboardStoreState {
  skus?: string[]
  tags?: string[]
  brands?: string[]
}

/**
 * The store class itself. An instance is created below and exported as
 * the default export.
 */
export class Store {

  state: ICommentsPinboardStoreState = {
    skus: [],
    tags: [],
    brands: []
  }

  set skus(skus: string[]) {
    this.state.skus = skus
  }

  get skus(): string[] {
    return this.state.skus
  }

  set tags(tags: string[]) {
    this.state.tags = tags
  }

  get tags(): string[] {
    return this.state.tags
  }

  set brands(brands: string[]) {
    this.state.brands = brands
  }

  get brands(): string[] {
    return this.state.brands
  }
}

export default new Store()




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/store/comments-pinboard-store.ts